import { collection, doc, getDocs, limit, orderBy, query, setDoc, updateDoc, where } from "firebase/firestore";
import { defineComponent, reactive, watch } from "vue";
import { printDate, printFullDate, printTime } from "../../../module/format-date";
import { computed } from "vue";
import { firebaseStore } from "../../../firebase";
import { onMounted, onUpdated } from "vue";
import axios from "axios";
export const mypageChatVApp = defineComponent({
    setup() {
        const jsIntegration = JSON.parse(document.querySelector("#js-integration")?.innerHTML || "{}");
        const state = reactive({
            me: {
                name: jsIntegration.me.name,
                userId: jsIntegration.me.id,
                iconChar: Array.from(jsIntegration.me.name).at(0) || "",
            },
            rooms: {},
            messages: {},
            selectedRoomId: "",
            chatModalVisible: false,
            inputMessage: "",
            weboothSlots: {},
            busy: false,
            sortDesc: null,
            sortBy: null,
            timerId: null,
            msgCount: 0,
            chatInfo: {},
            sortableRooms: [],
            currentUnReadCount: null,
            defaultAbsenceMessage: "ただいま不在しております。折り返しご連絡しますのでメッセージを送信してください。",
        });
        onMounted(async () => {
            // チャット取得
            await fetchMessages();
            // サプライヤー企業名をAPIから取得する
            let weboothSlotIds = Object.values(state.rooms).map((room) => room.weboothSlotId);
            // 重複を削除
            let setWeboothSlotIds = new Set(weboothSlotIds);
            weboothSlotIds = Array.from(setWeboothSlotIds);
            try {
                const response = await axios.get("/api/user/get-webooth-supplier-name", {
                    params: { webooth_slot_ids: weboothSlotIds },
                });
                for (const roomId in state.rooms) {
                    const data = response.data[state.rooms[roomId].weboothSlotId];
                    if (data === undefined) {
                        continue;
                    }
                    state.weboothSlots[state.rooms[roomId].weboothSlotId] = {
                        seriesName: data.series_name,
                        seriesCode: data.series_code,
                        productName: data.product_name,
                        supplierName: data.supplier_name,
                        weboothSlotId: state.rooms[roomId].weboothSlotId,
                        search: data.exhibitor_name,
                    };
                    state.chatInfo[roomId] = {
                        iconImageUrl: data.icon_image_url,
                        absenceMessage: data.absence_message,
                    };
                    state.sortableRooms.push({
                        ...state.rooms[roomId],
                        roomId: roomId,
                        hasUnRead: opened(roomId),
                        exhibitors: data.supplier_name,
                    });
                }
            }
            catch (error) {
                window.console.error(error);
            }
            // 未読を最初に表示するための設定
            state.sortBy = "hasUnRead";
            state.sortDesc = false;
            setSortBy("hasUnRead");
            const unreadCount = countUnread();
            await updateChatUnreadCount(unreadCount);
            await updateSupplierChatUnreadCount(unreadCount);
        });
        // チャットメッセージの更新
        onUpdated(async () => {
            if (state.selectedRoomId.length > 0) {
                // Refresh messages
                const mq = query(collection(firebaseStore, "rooms", state.selectedRoomId, "messages"), orderBy("sentAt"));
                const updateData = await getDocs(mq);
                const msgs = [];
                updateData.forEach(async (message) => {
                    msgs.push(message.data());
                });
                state.messages[state.selectedRoomId] = msgs;
                state.msgCount = state.messages[state.selectedRoomId].length;
                const unreadCount = countUnread();
                await updateChatUnreadCount(unreadCount);
                await updateSupplierChatUnreadCount(unreadCount);
            }
        });
        const fetchMessages = async () => {
            // 一ヶ月前のunixtime
            const deadline = Math.floor((Date.now() - 1000 * 3600 * 24 * 30) / 1000);
            // チャット取得
            const q = query(collection(firebaseStore, "rooms"), where("userId", "==", jsIntegration.me.id));
            const res = await getDocs(q);
            res.forEach(async (room) => {
                let lastUpdatedAt = 0;
                state.rooms[room.id] = room.data();
                const mq = query(collection(firebaseStore, "rooms", room.id, "messages"), orderBy("sentAt"), limit(100));
                const data = await getDocs(mq);
                if (data.size == 0) {
                    delete state.rooms[room.id];
                    return;
                }
                const messages = [];
                data.forEach(async (message) => {
                    // 最終送信日時を取得
                    lastUpdatedAt = message.data().sentAt.seconds;
                    messages.push(message.data());
                });
                // チャット一覧には１ヶ月以前は表示させない仕様のためルーム削除
                if (deadline > lastUpdatedAt) {
                    delete state.rooms[room.id];
                    return;
                }
                state.messages[room.id] = messages;
            });
        };
        const countUnread = () => {
            if (state.rooms == null) {
                return 0;
            }
            const len = Object.entries(state.sortableRooms).filter(([index, room]) => {
                console.log(room.roomId + "<>" + !opened(room.roomId));
                return !opened(room.roomId);
            })?.length ?? 0;
            return len;
        };
        // NOTE: メッセージを日付毎にグルーピングした配列を返す
        const currentMessages = computed(() => {
            if (state.messages[state.selectedRoomId] == null || Object.keys(state.messages[state.selectedRoomId]).length < 1) {
                return [];
            }
            const v = {};
            const dates = [];
            state.messages[state.selectedRoomId].forEach((message) => {
                const date = printFullDate(message.sentAt.seconds);
                // ソート用の配列
                dates.push(date);
                if (v[date] == null) {
                    v[date] = [];
                }
                v[date].push(message);
            });
            const res = [];
            Array.from(new Set(dates)).forEach((date) => {
                const unixtime = v[date][0].sentAt.seconds;
                const d = new Date(unixtime).getFullYear() === new Date().getFullYear() ? printDate(unixtime) : printFullDate(unixtime);
                res.push({
                    date: d,
                    messages: v[date],
                });
            });
            return res;
        });
        const printMessageTime = (unixtime) => {
            return printTime(unixtime);
        };
        const opened = (roomId) => {
            const room = state.rooms[roomId];
            const messages = state.messages[roomId];
            if (room == null || messages == null || messages.length < 1) {
                return false;
            }
            return !messages.some((message) => message.supplierMessage && !message.opened);
        };
        // タイマーをスタート
        const startTimer = () => {
            state.timerId = setTimeout(() => {
                absenceMessage();
            }, 60000 * 5);
        };
        // チャット中のサプライヤーがログイン中なのかチェック
        const checkSupplierLogin = async () => {
            const param = {
                supplier_id: state.rooms[state.selectedRoomId].supplierId,
            };
            try {
                const response = await axios.post("/api/user/check-supplier-login", param);
                if (!response.data.status) {
                    await absenceMessage();
                }
                else {
                    startTimer();
                }
            }
            catch (error) {
                window.console.error(error);
            }
        };
        const absenceMessage = async () => {
            const room = {
                seriesId: state.rooms[state.selectedRoomId].seriesId,
                weboothSlotId: state.rooms[state.selectedRoomId].weboothSlotId,
                supplierId: state.rooms[state.selectedRoomId].supplierId,
                userId: state.me.userId,
            };
            await setDoc(doc(firebaseStore, "rooms", state.selectedRoomId), room).then(async () => {
                const chatMessageRef = collection(firebaseStore, "rooms", state.selectedRoomId, "messages");
                let absenseMessage = state.defaultAbsenceMessage;
                if (state.chatInfo[state.selectedRoomId].absenceMessage !== "") {
                    absenseMessage = state.chatInfo[state.selectedRoomId].absenceMessage;
                }
                const item = {
                    roomId: state.selectedRoomId,
                    content: absenseMessage,
                    type: "message__plain-text",
                    supplierMessage: true,
                    opened: true,
                    sentAt: {
                        seconds: Math.floor(Date.now() / 1000),
                        nanoseconds: 0,
                    },
                };
                await setDoc(doc(chatMessageRef), item).then(async () => {
                    await fetchMessages();
                });
            });
        };
        const handleRawHtmlMessageClicked = (event, sourceElement) => {
            // 商談オファーメッセージ内にあるリンクがクリックされた場合のハンドリング
            if (sourceElement instanceof HTMLAnchorElement && sourceElement.dataset.linkTo === "supplier-offer") {
                const selectedRoom = state.rooms[state.selectedRoomId];
                const weboothSlotId = selectedRoom.weboothSlotId;
                const seriesCode = state.weboothSlots[weboothSlotId].seriesCode;
                globalThis.location.assign(`/u/${seriesCode}/webooth/reservation-calendar?id=${weboothSlotId}`);
                event.preventDefault();
            }
        };
        const handleToggleChat = async (roomId) => {
            if (roomId == undefined) {
                state.chatModalVisible = !state.chatModalVisible;
                return;
            }
            state.selectedRoomId = roomId;
            // HACK: キャッシュを使用して表示するとCSSが当たる前にコンポーネントが表示されてしまうので、
            // CSSのロードが完了してる1tick後にScroll処理をした後、詳細ページを表示する。
            setTimeout(() => {
                const chatArea = document.querySelector("#modal-chat-area");
                if (chatArea != null) {
                    chatArea.scrollTo(0, chatArea.scrollHeight);
                }
                state.chatModalVisible = !state.chatModalVisible;
            }, 500);
            // 既読付ける
            // NOTE: bulk update出来ないのでメッセージを個別にupdateする
            const messages = state.messages[roomId];
            if (messages == null || messages.length < 1) {
                return;
            }
            const lastMessage = messages[messages.length - 1];
            const q = query(collection(firebaseStore, "rooms", roomId, "messages"), where("sentAt", "<=", lastMessage.sentAt));
            const data = await getDocs(q);
            data.forEach(async (v) => {
                const message = v.data();
                if (message.supplierMessage) {
                    await updateDoc(v.ref, { opened: true });
                }
            });
            // Refresh messages
            const mq = query(collection(firebaseStore, "rooms", roomId, "messages"), orderBy("sentAt"));
            const v = await getDocs(mq);
            const msgs = [];
            v.forEach(async (message) => {
                msgs.push(message.data());
            });
            state.messages[roomId] = msgs;
            await updateChatUnreadCount(countUnread());
        };
        const handleSendMessage = async () => {
            if (state.busy) {
                return;
            }
            if (state.inputMessage === "") {
                return;
            }
            state.busy = true;
            try {
                const item = {
                    roomId: state.selectedRoomId,
                    content: state.inputMessage,
                    supplierMessage: false,
                    opened: false,
                    sentAt: {
                        seconds: Math.floor(Date.now() / 1000),
                        nanoseconds: 0,
                    },
                };
                const ref = collection(firebaseStore, "rooms", state.selectedRoomId, "messages");
                await setDoc(doc(ref), item).then(() => {
                    state.inputMessage = "";
                    state.messages[state.selectedRoomId].push(item);
                    // HACK: キャッシュを使用して表示するとCSSが当たる前にコンポーネントが表示されてしまうので、
                    // CSSのロードが完了してる1tick後にScroll処理をした後、詳細ページを表示する。
                    setTimeout(() => {
                        const chatArea = document.querySelector("#modal-chat-area");
                        if (chatArea != null) {
                            chatArea.scrollTo(0, chatArea.scrollHeight);
                        }
                    }, 500);
                });
                await sendNotificationEmail(state.rooms[state.selectedRoomId].weboothSlotId, item.content);
                await checkSupplierLogin();
            }
            catch {
            }
            finally {
                state.busy = false;
            }
        };
        const sendNotificationEmail = async (weboothSlotId, message) => {
            const param = {
                template_type: "message",
                message: message,
                target_webooth_slot_id: weboothSlotId,
            };
            try {
                await axios.post("/api/user/send-chat-notification-email", param);
            }
            catch (error) {
                window.console.error(error);
            }
        };
        const resizeMessageAreaHeight = (e) => {
            const textArea = e.target;
            if (textArea != null) {
                // 3行以上の高さ(77px = 3rem(1rem=14px) + 20px(padding))には設定しない
                if (Number(textArea.scrollHeight) <= 77) {
                    // 改行が削除された場合に、一度リセットする
                    textArea.style.height = "auto";
                    textArea.style.height = textArea.scrollHeight + "px";
                }
            }
        };
        const shouldRenderRawHtmlMessage = (message) => {
            return message.type === "offer__business";
        };
        const setSortedRooms = () => {
            if (!state.sortBy)
                return state.sortableRooms;
            state.sortableRooms = state.sortableRooms.sort((a, b) => {
                const sortBy = state.sortBy;
                const firstVal = a[sortBy];
                const secondVal = b[sortBy];
                if (firstVal < secondVal == state.sortDesc) {
                    return -1;
                }
                if (firstVal > secondVal == state.sortDesc) {
                    return 1;
                }
                // names must be equal
                return 0;
            });
        };
        const setSortBy = (key) => {
            //Log for check data
            state.sortBy = key;
            if (state.sortDesc == null) {
                state.sortDesc = false;
            }
            state.sortDesc = !state.sortDesc;
            setSortedRooms();
        };
        const getSortIcon = (key, isDefault) => {
            if (state.sortBy != key)
                return isDefault;
            if (state.sortDesc == null) {
                return isDefault;
            }
            else if (state.sortDesc) {
                return "arrow_upward";
            }
            else {
                return "arrow_downward";
            }
        };
        const updateSupplierChatUnreadCount = async (num) => {
            const unreadCountIds = ["side-menu-chat-unread-count", "supplier-chat-unread-count"];
            for (const id of unreadCountIds) {
                const span = document.getElementById(id);
                if (!span)
                    continue;
                span.className = "";
                if (num > 0) {
                    span.innerHTML = num.toString();
                    span.className = "counter";
                }
                else {
                    if (id == "supplier-chat-unread-count") {
                        span.innerHTML = num.toString();
                    }
                    else {
                        span.innerHTML = "(" + num.toString() + ")";
                    }
                }
            }
        };
        // チャット未読数の更新
        const updateChatUnreadCount = async (num) => {
            if (state.currentUnReadCount != num) {
                state.currentUnReadCount = num;
                try {
                    await axios.post("/api/u/mypage/chat/count", { userId: state.me.userId, chatUnReadCount: num });
                }
                catch (error) {
                    window.console.error(error);
                }
            }
        };
        watch(() => state.msgCount, (updateCount, prevCount) => {
            if (state.timerId !== null) {
                if (updateCount != prevCount) {
                    clearTimeout(state.timerId);
                    state.timerId = null;
                }
            }
        });
        return {
            state,
            currentMessages,
            printMessageTime,
            opened,
            handleToggleChat,
            handleSendMessage,
            resizeMessageAreaHeight,
            handleRawHtmlMessageClicked,
            countUnread,
            shouldRenderRawHtmlMessage,
            setSortBy,
            getSortIcon,
        };
    },
});
